<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>卓亿餐饮</h3>
          <p>{{ companyInfo.mission }}</p>
        </div>
        <div class="footer-section">
          <h3>联系方式</h3>
          <p><i class="el-icon-location"></i> {{ companyInfo.address }}</p>
          <p><i class="el-icon-phone"></i> {{ companyInfo.phone }}</p>
          <p><i class="el-icon-message"></i> {{ companyInfo.email }}</p>
        </div>
        <div class="footer-section">
          <h3>快捷导航</h3>
          <router-link to="/about">品牌介绍</router-link>
          <router-link to="/menu">特色服务</router-link>
          <router-link to="/stores">合作伙伴</router-link>
          <router-link to="/join">加盟招商</router-link>
        </div>
        <div class="footer-section">
          <h3>关注我们</h3>
          <img :src="config.baseUrl + '/static/files/gongzhonghao.jpg'" alt="微信公众号" class="qrcode-img">
          <p class="qrcode-text">扫码关注公众号</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p>Copyright © 2026 陕西卓亿餐饮管理有限公司 版权所有</p>
          <a href="https://beian.miit.gov.cn" target="_blank" style="color:#ffffff; text-decoration:none;">
            陕ICP备2024028404号-2
          </a>
          &nbsp;&nbsp;
          <img :src="config.baseUrl + '/static/files/gongan.png'"
               alt="公安备案图标"
               style="width:14px; height:14px; vertical-align:middle; margin-right:4px;">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=61011202001178"  rel="noreferrer" target="_blank" style="color:#ffffff; text-decoration:none;">
            陕公网安备61011202001178号
          </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { getCompanyInfo } from '@/api/company'
import config from '@/config'
export default {
  name: 'Footer',
  data() {
    return {
      companyInfo: {},
      config: config // ✅ 把配置挂载到 data，template 就能直接访问了
    }
  },
  mounted() {
    this.loadCompanyInfo()
  },
  methods: {
    async loadCompanyInfo() {
      try {
        const res = await getCompanyInfo()
        this.companyInfo = res.data || {}
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
.footer {
  background: #2c3e50;
  color: #fff;
  padding: 50px 0 20px;
  margin-top: auto;
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr 1.5fr 0.5fr 1fr;
  gap: 40px;
  margin-bottom: 30px;
}

.footer-section h3 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #4CAF50;
}

.footer-section p {
  margin-bottom: 10px;
  line-height: 1.8;
}

.footer-section i {
  margin-right: 8px;
}

.footer-section a {
  display: block;
  color: #ccc;
  text-decoration: none;
  margin-bottom: 10px;
  transition: color 0.3s;
}

.footer-section a:hover {
  color: #4CAF50;
}

.qrcode-img {
  width: 120px;
  height: 120px;
  display: block;
  margin: 0 auto;
}

.qrcode-text {
  text-align: center;
  font-size: 14px;
  margin-top: 10px;
}

.footer-bottom {
  border-top: 1px solid rgba(255,255,255,0.1);
  padding-top: 20px;
  text-align: center;
  color: #999;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
  }
}
</style>
